<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        
        <TabView class="tabview-custom tb-pr-st" style="margin-top: 0rem;" ref="tabview1">
            <TabPanel>
                <template #header>
                    <i class="pi pi-calendar"></i>
                    <span>SQL 쿼리</span>
                </template>    

                <div>
                    <Button label="실행" icon="pi pi-check" class="mt-2 mr-2"  @click="btnAct('RUN')" />
                    <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
                    <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
                    <span style ="color:red; font-weight:bold">
                        SQL 스크립트 : DROP 절대 사용하지 말것. 데이터 처리 ROLLBACK 안됨
                    </span>
                </div>
                <Textarea v-model="searchParams.query" rows="10" cols="228" style="margin-top: 1rem;margin-bottom: 1rem;"/>

                <DataTable id="dt" ref="dt" :value="dataList" responsiveLayout="scroll" :virtualScrollerOptions="{ itemSize: 40 }" 
                    tableStyle="min-height: 30rem" scrollable scrollHeight="450px">
                    <Column header="No" style="min-width:3em; max-width:3em">
                        <template #body="{index}">
                            {{ index + 1 }}
                        </template>    
                    </Column>
                    <!-- <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header"></Column> -->
                    <template v-for="col of columns" :key="col.field">  
                        <Column :field="col.field" :header="col.header"></Column>
                    </template>
                </DataTable>
            </TabPanel>
            <TabPanel>
                <template #header>
                    <i class="pi pi-calendar"></i>
                    <span>SP 컴파일</span>
                </template>    
                <div>
                    <Button label="컴파일" icon="pi pi-check" size="large" style="margin-top: 1rem;" @click="btnAct('COMPILE')" />
                </div>
                <Textarea v-model="searchParams.sp" rows="30" cols="228" style="margin-top: 1rem;margin-bottom: 1rem;"/>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";
import QueryService from '@/service/cm/QueryService';
import JsUtils from '@/utilities/JsUtils';


export default {
    setup() {
        onMounted(() => {

        })
        const searchParams = reactive({query:null});
        const toast = useToast();
        const confirm = useConfirm();
        const dataList = ref([]);
        const columns = ref([]);
        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 

        const queryService = new QueryService();

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "RUN":
                    sqlRun();
                    break;
                case "COMPILE":
                    spCompile();
                    break;
                default:
            }
        }

        const sqlRun = () => {
            if(searchParams.query == null) {
                return;
            }
            var sql = searchParams.query.toUpperCase();
            var index = sql.search('DROP');            
            if(index > -1) {
                toast.add({severity:'error', summary: 'SQL 쿼리 오류', detail: 'SQL 쿼리에 DROP 명령어는 사용할 수 없습니다', life: 3000});	
                return;
            }
            columns.value = [];                    

            queryService.sqlRun(searchParams).then(data => {
                
                if(data != null && data.length > 0) {
                    const firstrow = data[0];

                    const _columns = Object.keys(firstrow); 
                    const arr = _columns.toString().split(',');  

                    arr.forEach(column => {
                        let row = {'field': column, 'header': column};
                        //columns.value.push(row);  // 리스트에 제일 앞에 추가한다
                        columns.value.splice(0,0, row); // 리스트에서 제일 뒤에 추가 한다
                    });

                    dataList.value = data;
                }

            })
            .catch(error => {
                toast.add({severity:'error', summary: '쿼리 실행 오류', detail: error.message, life: 3000});	
            });  
        };

        const spCompile = () =>{
            if(searchParams.sp == null) {
                return;
            }

            confirm.require({
                message:'프로시져를 컴파일하시겠습니까?',
                header: '프로시져 컴파일',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    queryService.spCompile(searchParams).then(data => {
                        console.log("### 프로시져 실행 결과 data = "+ data);
                        toast.add({severity:'success', summary: '프로시져 컴파일 성공', detail: '프로시져가 정상적으로 컴파일 되었습니다', life: 3000});
                    })
                    .catch(error => {
                        toast.add({severity:'error', summary: '프로시져 컴파일 오류', detail: error.message, life: 3000});	
                    });         
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, users.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(users.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        return { 
            searchParams, dt, dataList, columns,
            btnAct, sqlRun, spCompile, downloadExcel, exportCSV
        }
    }
}
</script>

<style lang="scss" scoped>
.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}

@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
